<template>
  <div class="row">
    <v-layout row wrap>
      <v-flex lg4 md4 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <v-card-title class="card-header">
              <h4 class="earth-color">ADD MEMBER TYPE</h4>
              <div class="title-decoration"></div>
            </v-card-title>
            <v-container>
              <v-form @submit.prevent="postMembershipType()" ref="form" v-model="valid">
                <v-autocomplete
                  label="Select Membership Type"
                  v-model="type.membership_type"
                  :items="allMemberTypes"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="name"
                  item-value="public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
                <v-autocomplete
                  label="Select Residency"
                  v-model="type.residence"
                  :items="allResidenceTypes"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="name"
                  item-value="public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
                <v-autocomplete
                  label="Select Household"
                  v-model="type.household_id"
                  :items="allOfHouseHolds"
                  :rules="[v => !!v || 'Item is required']"
                  required
                  item-text="name"
                  item-value="public_id"
                  :loading="$loadingTrue"
                  class="futuristic-input"
                ></v-autocomplete>
                <v-text-field
                  label="Name"
                  v-model="type.name"
                  :rules="requiredRules"
                  required
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Number of Persons"
                  v-model="type.num_of_persons"
                  :rules="requiredRules"
                  required
                  min="0"
                  type="number"
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Number of Vehicles"
                  v-model="type.num_of_vehicles"
                  :rules="requiredRules"
                  required
                  min="0"
                  type="number"
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Number of Children"
                  v-model="type.num_of_children"
                  :rules="requiredRules"
                  required
                  type="number"
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Price (KES)"
                  v-model="type.price"
                  :rules="requiredRules"
                  required
                  type="number"
                  min="0"
                  step="0.1"
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Entry Discount (%)"
                  v-model="type.entry_discount"
                  :rules="requiredRules"
                  required
                  type="number"
                  min="0.0"
                  step="0.1"
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Activity Discount (%)"
                  v-model="type.activity_discount"
                  :rules="requiredRules"
                  required
                  type="number"
                  min="0.0"
                  step="0.1"
                  class="futuristic-input"
                ></v-text-field>
                <v-text-field
                  label="Accommodation Discount (%)"
                  v-model="type.accommodation_discount"
                  :rules="requiredRules"
                  required
                  type="number"
                  min="0.0"
                  step="0.1"
                  class="futuristic-input"
                ></v-text-field>
                <v-btn
                  depressed
                  :color="edit ? 'warning' : 'primary'"
                  type="submit"
                  block
                  class="futuristic-btn"
                >
                  {{ edit ? 'Update' : 'Add' }}
                </v-btn>
                <v-btn
                  v-if="edit"
                  depressed
                  color="error"
                  block
                  @click="cancelEdit()"
                  class="futuristic-btn mt-2"
                >
                  Cancel Edit
                </v-btn>
              </v-form>
            </v-container>
          </v-card>
        </v-container>
      </v-flex>
      <v-flex lg8 md8 sm12 xs12>
        <v-container>
          <v-card flat class="futuristic-card">
            <v-card-title class="card-header">
              <h4 class="earth-color">MEMBERSHIP TYPES</h4>
              <v-spacer></v-spacer>
              <v-text-field
                append-icon="mdi-magnify"
                label="Search Membership Types"
                single-line
                hide-details
                v-model="search"
                class="futuristic-input"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="columns"
              :items="allMemberSettings"
              :search="search"
              :items-per-page-options="[10, 25, { text: 'All', value: -1 }]"
              :disable-initial-sort="true"
              :loading="$loadingTrue"
              class="futuristic-table"
            >
              <v-progress-linear slot="progress" color="primary" indeterminate></v-progress-linear>
              <template v-slot:items="props">
                <td>{{ props.item.membership_type }}</td>
                <td>{{ props.item.name }}</td>
                <td>
                  Persons: {{ props.item.number_of_persons }}. Vehicles: {{ props.item.number_of_vehicles }}. Children: {{ props.item.number_of_children }}
                </td>
                <td>{{ props.item.residence }}</td>
                <td>{{ $roundOff(props.item.price) }}</td>
                <td>
                  <li><b>Entry:</b> {{ props.item.entry_discount }}%</li>
                  <li><b>Activity:</b> {{ props.item.activity_discount }}%</li>
                  <li><b>Accommodation:</b> {{ props.item.accommodation_discount }}%</li>
                </td>
                <td>
                  <v-btn
                    depressed
                    color="warning"
                    small
                    v-if="!edit"
                    @click="editMembership(props.item)"
                    class="futuristic-btn"
                  >
                    Edit
                  </v-btn>
                  <v-btn
                    depressed
                    color="error"
                    small
                    v-if="edit"
                    @click="cancelEdit()"
                    class="futuristic-btn"
                  >
                    Cancel Edit
                  </v-btn>
                  <v-btn
                    depressed
                    color="error"
                    small
                    v-if="!edit"
                    @click="deleteMembershipType(props.item.public_id)"
                    class="futuristic-btn"
                  >
                    Disable
                  </v-btn>
                </td>
              </template>
              <v-alert slot="no-results" :value="true" color="error" icon="mdi-alert" class="futuristic-alert">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  data() {
    return {
      edit: false,
      valid: true,
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      search: '',
      type: {
        household_id: '',
        membership_type: '',
        name: '',
        num_of_persons: 1,
        num_of_vehicles: 0,
        num_of_children: 0,
        price: '',
        residence: '',
        public_id: '',
        entry_discount: '',
        activity_discount: '',
        accommodation_discount: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      columns: [
        {
          text: 'Type',
          value: 'membership_type'
        },
        {
          text: 'Name',
          value: 'name'
        },
        {
          text: 'Description',
          value: ''
        },
        {
          text: 'Residency',
          value: 'residence'
        },
        {
          text: 'Price (KES)',
          value: 'price'
        },
        {
          text: 'Discounts',
          value: ''
        },
        {
          text: 'Action',
          value: ''
        }
      ]
    }
  },
  created() {
    this.$store.dispatch('get_all_house_holds')
    this.$store.dispatch('get_all_membership_settings')
    this.$store.dispatch('get_all_residence_types')
    this.$store.dispatch('get_all_member_types')
  },
  methods: {
    cancelEdit: function() {
      this.edit = false
      this.type.household_id = ''
      this.type.membership_type = ''
      this.type.name = ''
      this.type.num_of_persons = ''
      this.type.num_of_vehicles = ''
      this.type.num_of_children = ''
      this.type.price = ''
      this.type.residence = ''
      this.type.public_id = ''
      this.type.entry_discount = ''
      this.type.activity_discount = ''
      this.type.accommodation_discount = ''
    },
    editMembership: function(settings) {
      this.edit = true
      this.type.household_id = settings.household_id
      this.type.membership_type = settings.membership_type_id
      this.type.name = settings.name
      this.type.num_of_persons = settings.number_of_persons
      this.type.num_of_vehicles = settings.number_of_vehicles
      this.type.num_of_children = settings.number_of_children
      this.type.price = settings.price
      this.type.residence = settings.residence_id
      this.type.public_id = settings.public_id
      this.type.entry_discount = settings.entry_discount
      this.type.activity_discount = settings.activity_discount
      this.type.accommodation_discount = settings.accommodation_discount
    },
    deleteMembershipType: function(publicId) {
      var data = {
        public_id: publicId,
        session_id: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_membership_setting', data)
    },
    postMembershipType: function() {
      var instance = this
      if (this.edit === false) {
        this.$store.dispatch('post_member_type', this.type)
      } else {
        this.$store.dispatch('update_member_type', this.type)
      }
    }
  }
}
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
}

.futuristic-search {
  max-width: 250px;
}

.futuristic-search >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  border-radius: 8px;
  margin: 0 8px 8px;
}

.futuristic-table >>> table {
  border-collapse: separate;
  border-spacing: 0;
}

.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
  font-size: 13px;
}

.futuristic-table >>> tbody tr {
  transition: background-color 0.2s ease;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f5f7fa;
}

.futuristic-link {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.futuristic-link:hover {
  color: #0d47a1;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 8px;
}

/* Title decoration for consistency */
.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px;
  }

  .futuristic-search {
    max-width: 100%;
    margin-top: 12px;
  }

  .futuristic-table {
    margin: 0 4px 4px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-table >>> tbody tr td {
    font-size: 12px;
    padding: 0 8px;
  }

  .futuristic-btn {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    border-radius: 6px;
  }

  .futuristic-btn {
    font-size: 0.85rem;
  }

  .futuristic-table {
    margin: 0 4px 4px;
    overflow-x: auto;
  }

  .futuristic-table >>> table {
    min-width: 700px; /* Ensure table is wide enough for all columns */
  }

  .futuristic-table >>> thead {
    display: table-header-group;
  }

  .futuristic-table >>> tbody tr {
    display: table-row;
  }

  .futuristic-table >>> tbody tr td {
    display: table-cell;
    font-size: 0.85rem;
    padding: 6px 8px;
  }

  .futuristic-table >>> thead tr th {
    font-size: 0.85rem;
    padding: 6px 8px;
  }
}
</style>
